import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../styles.module.scss';
import ChevronRight from './icons/chevron-right.svg';
export var ActionsColumn = function () {
    return (_jsx("div", { className: styles.center, children: _jsx(ChevronRight, {}) }));
};
